import * as Types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [Types.GET_ADMIN_USERS_BEGIN](state) {
    state.adminUsersGetState = API_STATES.REQUEST_PENDING;
  },
  [Types.GET_ADMIN_USERS_SUCCESS](state, users) {
    state.adminUsersGetError = null;
    state.adminUsers = users.list;
    state.usersCount = users.count
    state.adminUsersGetState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.GET_ADMIN_USERS_ERROR](state, err) {
    state.adminUsersGetState = API_STATES.REQUEST_ERROR;
    state.adminUsersGetError = err;
  },

  [Types.SEND_RESET_PASSWORD_LINK_BEGIN](state) {
    state.sendResetPasswordState = API_STATES.REQUEST_PENDING;
  },
  [Types.SEND_RESET_PASSWORD_LINK_SUCCESS](state) {
    state.sendResetPasswordError = null;
    state.sendResetPasswordState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.SEND_RESET_PASSWORD_LINK_ERROR](state, err) {
    state.sendResetPasswordState = API_STATES.REQUEST_ERROR;
    state.sendResetPasswordError = err;
  },

  [Types.DELETE_USER_BEGIN](state) {
    state.adminUserDeleteState = API_STATES.REQUEST_PENDING;
  },
  [Types.DELETE_USER_SUCCESS](state) {
    state.adminUserDeleteError = null;
    state.adminUserDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.DELETE_USER_ERROR](state, err) {
    state.adminUserDeleteState = API_STATES.REQUEST_ERROR;
    state.adminUserDeleteError = err;
  },

  [Types.ASSIGN_REVOKE_ADMIN_RIGHTS_BEGIN](state, userId) {
    state.assignRevokeAdminRightsPending.push(userId);
  },
  [Types.ASSIGN_REVOKE_ADMIN_RIGHTS_SUCCESS](state, { userId, hasRoleSuperAdmin }) {
    state.assignRevokeAdminRightsError = null;
    state.adminUsers.find(u => u.id === userId)
    
    const userRecordIndex = findIndex(state.adminUsers, { id : userId });
    state.adminUsers[userRecordIndex].hasEpicorAdminRole = hasRoleSuperAdmin === 0

    const index = findIndex(state.assignRevokeAdminRightsPending, userId);
    state.assignRevokeAdminRightsPending.splice(index, 1)
  },
  [Types.ASSIGN_REVOKE_ADMIN_RIGHTS_ERROR](state, { error, userId }) {
    const index = findIndex(state.assignRevokeAdminRightsPending, userId);
    state.assignRevokeAdminRightsPending.splice(index, 1)
    state.assignRevokeAdminRightsError = error;
  }
};

export default mutations;